import { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import get from 'lodash/get';
import classNames from 'clsx';
import {
  SUBSCRIBE_PAYMENT_FORM_COUNTRY,
  SUBSCRIBE_PAYMENT_FORM_STATE,
} from 'src/common/constants/localizations/subscription';
import { states } from 'src/data/states.json';
import countries from 'src/data/countries.json';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import Label from '../../shared/form/Label';
import Select from '../../shared/form/Select';
import css from '../payment.module.scss';

const countryList = countries.map((c) => ({ name: c.name, value: c.iso2 }));

const CountryStateField = ({ form, enableManualSelection }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const stateList = states[get(form, 'values.country')];

  if (!enableManualSelection) {
    return null;
  }

  return (
    <Fragment>
      <Label labelText="Country" dataTestId="countryLabel" isRequired />
      <div
        data-testid="countryContainer"
        className={classNames('row', css.paymentFieldSection)}
      >
        <div data-testid="paymentCountryContainer" className="col-xs-12">
          <Field
            component={Select}
            tabIndex={12}
            id="paymentCountry"
            data-testid="paymentCountry"
            name="country"
            options={countryList}
            defaultOptionName={getLocalizedText(SUBSCRIBE_PAYMENT_FORM_COUNTRY)}
          />
        </div>
      </div>
      <Label labelText="State" dataTestId="stateLabel" isRequired />
      <div
        data-testid="stateContainer"
        className={classNames('row', css.paymentFieldSection)}
      >
        <div data-testid="paymentStateContainer" className="col-xs-12">
          <Field
            component={Select}
            tabIndex={13}
            id="paymentState"
            data-testid="paymentState"
            name="state"
            disabled={!stateList}
            options={stateList}
            defaultOptionName={getLocalizedText(SUBSCRIBE_PAYMENT_FORM_STATE)}
          />
        </div>
      </div>
    </Fragment>
  );
};

CountryStateField.propTypes = {
  enableManualSelection: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
};

export default CountryStateField;
